import React, { useContext, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import Spinner from "../../../Component/Spinner";
import { AuthContext } from "../../../contexts/AuthProvider";

const MyProduct = () => {
  const { user, loading } = useContext(AuthContext);
  const [displayProducts, setDisplayProducts] = useState([]);

  const url = "https://bike-resell-server-hasanalibd.vercel.app/advertise";

  const { data: bikes = [], refetch } = useQuery({
    queryKey: ["advertise", user?.email],
    queryFn: async () => {
      const res = await fetch(url);
      const data = await res.json();
      return data;
    },
  });

  //  delete product handle
  const handleDelete = (bike) => {
    const agree = window.confirm(
      `Are you sure you want to delete: ${bike.model}`
    );
    if (agree) {
      // console.log('deleting user with id:', user._id);
      fetch(
        `https://bike-resell-server-hasanalibd.vercel.app/advertise/${bike._id}`,
        {
          method: "DELETE",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.deletedCount > 0) {
            const remaingingList = displayProducts.filter(
              (usr) => usr._id !== bike._id
            );
            setDisplayProducts(remaingingList);
            toast.warning("Deleted Successfully");
            refetch();
          }
        });
    }
  };

  const handleAdvertise = (bike) => {
    const {
      brand,
      model,
      condition,
      sellingPrice,
      Engine,
      running,
      sellerName,
      sellerEmail,
      sellerPhone,
      sellerLoaction,
      img,
    } = bike;

    fetch(
      `https://bike-resell-server-hasanalibd.vercel.app/advertise/${bike._id}`,
      {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          brand,
          model,
          condition,
          sellingPrice,
          Engine,
          running,
          sellerName,
          sellerEmail,
          sellerPhone,
          sellerLoaction,
          img,
          mode: "public",
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.acknowledged) {
          toast.success(" Advertise Successfully");
        }
      });
  };

  if (loading) {
    return <Spinner></Spinner>;
  }

  return (
    <div className="mt-10 mx-10">
      <h1 className="text-3xl font-semibold text-center text-[#149777] mb-5">
        My Products: {bikes.length}
      </h1>
      <d iv className="overflow-x-auto">
        <table className="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Photos</th>
              <th>name</th>
              <th>Advertisement</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {bikes.map((bike, i) => (
              <tr key={bike._id}>
                <th>{1 + i}</th>
                <th>
                  <div className="avatar">
                    <div className="w-12 rounded-full">
                      <img
                        src={
                          bike.img
                            ? bike.img
                            : "https://placeimg.com/192/192/people"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </th>
                <th>{bike.model}</th>
                <th>
                  <button
                    onClick={() => handleAdvertise(bike)}
                    className="btn btn-secondary "
                  >
                    Advertise
                  </button>
                </th>
                <th>
                  <button
                    onClick={() => handleDelete(bike)}
                    className="btn btn-warning"
                  >
                    Delete
                  </button>
                </th>
              </tr>
            ))}
          </tbody>
        </table>
      </d>
    </div>
  );
};

export default MyProduct;
